import { ChangeDetectorRef, Component, OnInit, ElementRef,  Renderer2, EventEmitter, Output, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Config, Link, Menu, MenuPrte } from 'src/app/models/menu';
import { Router } from '@angular/router';
import {
  MessagesService,

  SpinnerService
} from '../../../services/service.index';
import { RequestMessage } from '../../../models/common/requestMessage.model';
// import { FormList, Forms } from '../../../models/form.io/formList.model';
import { responseLogin } from '../../../models/login/login.model';
import { CommonService } from '../../../services/common/common.service';
// import { FormIOService } from '../../../services/common/formIO.service';
import { PageService } from '../../../services/shared/page.service';
import { Page } from 'src/app/models/page.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ColorAdjustmentUtils } from '../../utilities/color-adjustment.utils';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { Company, Program, UserModel } from 'src/app/models/auth/_models/user.model';
import { BehaviorSubject, Observable} from 'rxjs';
import { CompanyService } from 'src/app/services/company.service';
import { Favorite } from 'src/app/models/auth/_models/favorite';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { MainModel } from 'src/app/models/auth/_models/main-model';
import { DxTreeViewComponent } from 'devextreme-angular';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { ResourceParameter } from 'src/app/services/microapplications/_models/resource-parameter.model';
import { MainService } from 'src/app/services/shared/main.service';
import { FavoriteService } from 'src/app/services/common/favorite.service';
declare function resetMenu(): any;
declare function encryptString(plainText: string): any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  adjustedColor: string | undefined;
  adjustedColorClass = 'primary-color-adjusted';
  @ViewChild('miniMenuRef', { static: false }) miniMenuRef!: ElementRef;
  @ViewChild('sp_aside', { static: false }) sp_aside: ElementRef;
  @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
  @Input() options;
  isMobile: boolean = false;
  createChildren: DxTreeViewComponent['createChildren'];
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  Name: string = '';
  public favorites: Favorite[] = [];
  pagesSe: Page[] = [];
  pagesSes: Page[] = [];
  public userInfo: any = {};
  public menu: Menu[] = [];
  public menuSub: Menu[] = [];
  // public dynamicForms: Forms[] = [];
  public dynamicFormsList: Menu[] = [];
  public userSearch: any = '';
  rightMenuOpened: boolean = false;
  public adproForms: any;
  public dynamicFormsList2: any;
  public windowAddFavorite: boolean;
  public windowTopLeftPosition: any = { x: 0, y: 0 };
  public listFavorite: any = [];
  public nodeData: any;
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');

  config: Config;
  menus: MenuPrte[] = [
    {
      name: 'Front-end',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        { name: 'HTML', url: '#' },
        { name: 'CSS', url: '#' },
        { name: 'Javascript', url: '#' }
      ]
    },
    {
      name: 'Responsive web',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        { name: 'Tablets', url: '#' },
        { name: 'Mobiles', url: '#' },
        { name: 'Desktop', url: '#' }
      ]
    },
    {
      name: 'Web Browser',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { name: 'Chrome', url: '#' },
        { name: 'Firefox', url: '#' },
        { name: 'Desktop', url: '#' }
      ]
    }
  ];

  public codUser: string;
  public updateFavorite: any[];
  public listHistorial = JSON.parse(
    sessionStorage.getItem('listHisotrial') || '[]'
  );
  public pageArray: Page[] = [];
  public pageStorage: any;
  pages: Page[] = [];
  public opheliaform: string = '';
  public selectedIndex: any;
  public guidOph: any;
  public tokenOph: any;
  browserName: string = '';
  public keyEnter: boolean = false;
  public ShowFavorites: boolean = false;
  public pageOph: any = [];
  versionFormas: string;
  menuIndex: any//index de menus solo para edge de nuevo front
  photo: any;
  menuSeven: MainModel[];
  codigoForm: string;
  tokeshistori: string;
  conpany: string;
  usersession: string;
  selectedItem: Company;
  variable: boolean;
  companynameSelect: string;
  Linkdata: Link[]= [];
isSidebarCollapsed: boolean=false;
listHistorialclick: boolean=false;
  photouser: any;
  isDrawerOpen: boolean;


  constructor(



    private domSanitizer: DomSanitizer,
    // public _sideBarService: SidebarService,
    public _commandService: CommonService,
    private _pageService: PageService,
    private _messagesService: MessagesService,
    private microapps: MicroapplicationService,
    private router: Router,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private _spinnerService: SpinnerService,
    private _commonService: CommonService,
    private _router: Router,
    private auth: AuthService,
    private companyService: CompanyService,
    // private favoritesService: FavoriteService,
    private favoritesService: FavoriteService,
    private mainHttpService: MainHTTPService,
    private sanitizer: DomSanitizer,
    public mainService: MainService,
    private ChangeDetectorRef: ChangeDetectorRef,
    
  ) {
    this.codUser = '';
    this.windowAddFavorite = false;
    this.updateFavorite = [];
    // this._sideBarService.setComponentInstance(this);


    this.createChildren = (parent) => {
      const parentId = parent ? parent.itemData.id : 0;
      return this.mainHttpService.loadMenu(parentId).toPromise();
    };
    // this.photouser=(  this.auth.getUserPhotoProfile(this.sessionData.username).subscribe(resp=>{
    //   return resp;
 
    //   // this.changes.detectChanges();
    // }))
  
  
    // this.photouser= this.auth.getUserPhotoProfiles(this.sessionData.username)
  }

  public year: string = '';
  public version: string = '';
  public ShowMenu = true;
  public newListener = false;
  public observer: MutationObserver;
  public isSearching = true;
  html: SafeResourceUrl;
  // variables combo empresa
  public empresaSelect: any;
  // public empresaLista: any = {};
  // empresaLista: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public empresaLista: any = {};

  emplista: Observable<Company[]>;
  public codEmpresa: string | null | undefined;
  mainDataSearch: MainModel[] = [];
  public empresaAdminProcess: any;
  public empresaAdminNomProcess: any;
  user$: Observable<UserModel>;
  companies: any;

  @ViewChild("empresa") empresa: any;
  @Output() eventSelectEnterprise: EventEmitter<any> = new EventEmitter();


  ngOnInit(): void {

  document.addEventListener('mousemove', (e) => {
    document.documentElement.style.setProperty('--mouse-x', e.clientX.toString());
    document.documentElement.style.setProperty('--mouse-y', e.clientY.toString());
  });
    this.user$ = this.auth.currentUserSubject.asObservable();
    
    this.codEmpresa = this.sessionData.selectedCompany.code;
    this.conpany = this.sessionData.selectedCompany.code;
    this.lookForCompaniesChanges();
     this.lookForDataMenu();
    // alert(this.conpany);
    this.getPhotouser();



    const data = this.user$;



    this.loadCompanies();
    this.browserName = this._pageService.detectBrowserName();
    this.favoriteList(true);
    this.showLoading()

    // this.spinner.show();
    setTimeout(() => {
      this.closeLoading();
    
    }, 2000);
    document.addEventListener('click', this.handleDocumentClick);


    this.userInfo = data;
    
    this.Name = this.usersession;
    const body = document.querySelector('body');
    const defaultPrimaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
    const luminosity = 0.08; // Ejemplo de valor de ajuste
    const adjustedColor = ColorAdjustmentUtils.adjustColorLuminosity(defaultPrimaryColor, luminosity);

    // Asignar el valor a --primary-coempresaListalor-adjusted en lugar de --primary-color
    document.documentElement.style.setProperty('--primary-color-adjusted', adjustedColor);

    window.addEventListener('resize', this.saveMobile);
    // this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.observer = new MutationObserver(mutations => {
      // mutations.forEach(mutation => {
      //   if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.nodeName === 'BODY') {
      let body = document.querySelector('body');
      let res = body?.classList.contains('sp-aside--minimize');
      if (res) sessionStorage.setItem('toMenu', 'savechanged');
      else sessionStorage.removeItem('toMenu');
      //   }
      // });
    });

    // this.getPhoto();
    // this.loadCompanies();
    this.config = this.mergeConfig(this.options);
   
  }

  
  mergeConfig(options: Config) {
 
    const config = {
      // selector: '#accordion',
      multi: true
    };

    return { ...config, ...options };
  }


  toggled(index: number) {
  
    if (!this.config.multi) {
      this.menu.filter(
        (menu, i) => i !== index && menu.active
      ).forEach(menu => menu.active = !menu.active);
    }
    this.menu[index].active = !this.menu[index].active;
  }

  // METODO NUEVO SEVENERP
  getPhoto() {
    // this.auth.getUserPhotologoProfile(this.auth.currentUserValue.selectedCompany.code).subscribe(resp=>{
    this.auth.getUserPhotologoProfile(this.conpany).subscribe(resp => {
      this.photo = resp;
      // this.cdr.detectChanges();
    });
  }

  getPhotouser(){
    this.auth.getUserPhotoProfile(this.sessionData.username).subscribe(resp=>{
      this.photouser= resp;
 
      // this.changes.detectChanges();
    });
  }


  async loadCompanies() {

    this.companyService.getCompanies().subscribe(
      resp => {
        this.companies = resp;

        this.selectedItem = this.companies.filter(
          obj =>
            obj.code == this.codEmpresa
        );

        const der = this.companies.filter(
          obj =>
            obj.code == this.codEmpresa
        );
        // this.selectedItem =  this.companies[0];
        this.empresaLista = resp;
        this.ChangeDetectorRef.detectChanges();
        // this.titleService.setTitle(`Seven ERP 24.0.9.0`);
      });

  }
  // -----------------------

  ngAfterViewInit() {
    this.saveMobile();
    if (!this.versionFormas) {

    }

    
  }

  ngOnDestroy() {
    // remove the event listener when the component is destroyed
    document.removeEventListener('click', this.handleDocumentClick);
    window.removeEventListener('resize', this.saveMobile);
    this.observer?.disconnect();
  }


  verifyUrl(data: any, pos: any) {
    if (data.nodes) {
      data.nodes.forEach((e: any) => {
        this.verifyUrl(e, pos);
      })
    } else if (data.url && data.url.includes('/formio/')) {
      if (this.menuIndex.indexOf(pos) == -1) {
        this.menuIndex.push(pos)
      }
    }
  }

  // función para esperar a que se cargue completamente el menú lateral
  private waitForMenuLoad(): Promise<void> {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (this.menu && this.menu.length > 0) {
          clearInterval(intervalId);
          resolve();
        }
      }, 100);
    });

  }


  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }

  generarPage(node: any, add = true) {
   
    if (add) {
      this.addHistorial(node);
    }
    const page: Page = {
      codProg: node.codigoPrograma,
      name: this.toTitleCase(node.name),
      idForm: node.idForm,
      id: 0,
      url: node.url.toLowerCase(),
      cambiarUrl: true,
      typeForm: node.url.includes('adpro') ? 'adpro' : 'maestro',
      lisnk:null
    };
    this.removeClass('open-item');

    let elemento = document.querySelector(`.sp-menu__link:not(.sp-menu__toggle)[name=${page.codProg}]`) as HTMLElement;
    if (node?.par_prog) page.url = page.url + '&par_prog=' + node.par_prog;

    else {
      this._pageService.generarPage(page);
    }
  }
  // onClicklistmenu(indext: number, idmenu: any, reloadMenu: boolean) {
  //   // this.showLoading()
  //   // this.spinner.show();



  //   if (!this.menu[indext].nodes) {
  //     for (let  i = 0; i < this.menu.length; i++) {

  //       if (!this.config.multi) {
  //         this.menu[i].nodes.filter(
  //           (menu, i) => i !== indext && menu.active
  //         ).forEach(menu => menu.active = !menu.active);
  //       }
  //       this.menu[indext].active = !this.menu[indext].active;
  //     }

  //   }
  //   else {


  //     if (!this.menu[0].nodes[indext]) {
  //       for (let i = 0; i < this.menu.length; i++) {

  //         if (!this.config.multi) {
  //           this.menu[i].nodes.filter(
  //             (menu, i) => i !== indext && menu.active
  //           ).forEach(menu => menu.active = !menu.active);
  //         }
  //         this.menu[indext].active = !this.menu[indext].active;
  //       }

  //     }


  //     for (let i = 0; i < this.menu.length; i++) {

  //       if (this.menu[i].nodes.length > 0 || this.menu[i].nodes) {
  //         let listmenu = this.menu[i].nodes.find(a => a.codigoPrograma == idmenu);
  //         if (listmenu) {

  //           if (listmenu.nodes == null) {
  //             if (!this.config.multi) {
  //               this.menu[i].nodes.filter(
  //                 (menu, i) => i !== indext && menu.active
  //               ).forEach(menu => menu.active = !menu.active);
  //             }
  //             this.menu[i].nodes[indext].active = !this.menu[i].nodes[indext].active;

  //             return
  //           }
  //         }
  //       }
  //     }
  //   }



  //   this.mainHttpService.get(idmenu).subscribe(resp => {
  //     if (resp.isSuccessful) {
  //       this.menuSeven = resp.result;
  //       if (resp.result.length > 0) {
  //         for (let i = 0; i < this.menuSeven.length; i++) {

  //           let index = this.menuSub.findIndex(item => item.codigoPrograma === this.menuSeven[i].id,);
  //           if (index > -1) {
  //           } else {
  //             // add the new item which dosen't exist
  //             this.menuSub.push({
  //               codigoPrograma: this.menuSeven[i].id,
  //               group: idmenu,
  //               idForm: null,
  //               idMenu: this.menuSeven[i].id,
  //               idParent: idmenu,
  //               name: this.menuSeven[i].text,
  //               url: this.menuSeven[i].text,
  //               active: true,
  //               icono: null
  //             })

  //           }


  //         }
  //         let listmenu = this.menu.find(a => a.codigoPrograma == idmenu);
  //         if (listmenu) {
  //           listmenu.nodes = null;
  //           listmenu.idMenu = "1";
  //           listmenu.group = idmenu,
  //             listmenu.nodes = this.menuSub;
  //           for (let i = 0; i < this.menu.length; i++) {

  //             if (!this.config.multi) {
  //               this.menu[i].nodes.filter(
  //                 (menu, i) => i !== indext && menu.active
  //               ).forEach(menu => menu.active = !menu.active);
  //             }
  //             this.menu[indext].active = !this.menu[indext].active;
  //           }
  //           return
  //         }
  //         else {
  //           for (let i = 0; i < this.menu.length; i++) {

  //             let listmenu = this.menu[i].nodes.find(a => a.codigoPrograma == idmenu);
  //             if (listmenu) {
  //               listmenu.nodes = null;
  //               listmenu.idMenu = "1";
  //               listmenu.group = idmenu,
  //                 listmenu.nodes = this.menuSub;


  //               if (!this.config.multi) {
  //                 this.menu[i].nodes.filter(
  //                   (menu, i) => i !== indext && menu.active
  //                 ).forEach(menu => menu.active = !menu.active);
  //               }
  //               this.menu[i].nodes[indext].active = !this.menu[i].nodes[indext].active;

  //               return
  //             }
  //           }


  //         }


  //       }

  //       // this.closeLoading();
  //     }
  //     else {
  //       this._messagesService.error("Error conectando con el proveedor de menú");
  //     }
  //   });


  // }

  onClicklistmenu(indext: number, idmenu: any, reloadMenu: boolean): void {
  if (!this.menu[indext].nodes) {
    this.deactivateOthersAndToggle(indext);
    return;
  }

  if (!this.menu[0].nodes[indext]) {
    this.deactivateOthersAndToggle(indext);
  }

  if (this.findAndToggleLeafNode(indext, idmenu)) return;

  this.loadMenuFromServer(indext, idmenu);
}

// ─── Helpers de activación ───────────────────────────────────────────

private deactivateOthersAndToggle(indext: number): void {
  for (const menuItem of this.menu) {
    if (!this.config.multi) {
      this.deactivateOthers(menuItem.nodes, indext);
    }
  }
  this.menu[indext].active = !this.menu[indext].active;
}

private deactivateOthers(nodes: any[], indext: number): void {
  nodes
    .filter((menu, i) => i !== indext && menu.active)
    .forEach(menu => menu.active = false);
}

private findAndToggleLeafNode(indext: number, idmenu: any): boolean {
  for (const menuItem of this.menu) {
    if (!menuItem.nodes?.length) continue;

    const found = menuItem.nodes.find((a: any) => a.codigoPrograma == idmenu);
    if (!found?.nodes) continue;

    if (!this.config.multi) {
      this.deactivateOthers(menuItem.nodes, indext);
    }
    menuItem.nodes[indext].active = !menuItem.nodes[indext].active;
    return true;
  }
  return false;
}

// ─── Carga desde servidor ────────────────────────────────────────────

private loadMenuFromServer(indext: number, idmenu: any): void {
  this.mainHttpService.get(idmenu).subscribe({
    next: (resp) => {
      if (!resp.isSuccessful) {
        this._messagesService.error("Error conectando con el proveedor de menú");
        return;
      }
      if (resp.result.length > 0) {
        this.mergeMenuItems(resp.result, idmenu);
        this.assignNodesToMenu(indext, idmenu);
      }
    },
    error: () => this._messagesService.error("Error conectando con el proveedor de menú")
  });
}

private mergeMenuItems(results: any[], idmenu: any): void {
  for (const item of results) {
    const exists = this.menuSub.some(s => s.codigoPrograma === item.id);
    if (!exists) {
      this.menuSub.push({
        codigoPrograma: item.id,
        group:          idmenu,
        idForm:         null,
        idMenu:         item.id,
        idParent:       idmenu,
        name:           item.text,
        url:            item.text,
        active:         true,
        icono:          null
      });
    }
  }
}

private assignNodesToMenu(indext: number, idmenu: any): void {
  const topLevel = this.menu.find((a: any) => a.codigoPrograma == idmenu);

  if (topLevel) {
    this.applyNodes(topLevel, idmenu);
    this.deactivateOthersAndToggle(indext);
    return;
  }

  for (const menuItem of this.menu) {
    const nested = menuItem.nodes?.find((a: any) => a.codigoPrograma == idmenu);
    if (!nested) continue;

    this.applyNodes(nested, idmenu);
    if (!this.config.multi) {
      this.deactivateOthers(menuItem.nodes, indext);
    }
    menuItem.nodes[indext].active = !menuItem.nodes[indext].active;
    return;
  }
}

private applyNodes(menuItem: any, idmenu: any): void {
  menuItem.nodes  = this.menuSub;
  menuItem.idMenu = "1";
  menuItem.group  = idmenu;
}
  onRightClick(event: MouseEvent, node: any) {

    this.windowAddFavorite = true;
    this.windowTopLeftPosition.x = event.clientX + 'px';
    this.windowTopLeftPosition.y = event.clientY - 30 + 'px';
    this.nodeData = node;

    event.preventDefault();
  }

  addFavorite(event: MouseEvent, node: any) {
    this.nodeData = node;
    event.preventDefault();
    this.windowAddFavorite = false;
    this.sessionData;
    const filter = this.listFavorite.filter(
      (filterFavorite: any) =>
        filterFavorite.cod_prog === this.nodeData.codigoPrograma
    );
    if (filter.length === 1) {
      // this.favoriteService.deletedFavorite(node.codigoPrograma).subscribe(res => { });
      this.windowAddFavorite = false;
    } else if (filter.length < 1) {
      // this.favoriteService.addFavorite(this.nodeData).subscribe(() => {
      //   this.windowAddFavorite = false;
      // });
      (event.target as Element).classList.remove('far');
      (event.target as Element).classList.add('fas');
      // (event.target as Element as HTMLElement).style.setProperty(
      //   'color',
      //   '#FFF'
      // );
    }
  }

  itemClick(e) {    

    let mainItem : Program = e.itemData;
     let favorite:any = {
      fav_maid : mainItem.id, 
      emp_codi: this.codEmpresa
    }    
    this.favoritesService.addFavorite(favorite);

  }
  addHistorial(node: any) {
   
    let index = this.listHistorial.findIndex(
      (e: any) => e.idForm == node.idForm
      
    );
    if (index != -1) {
      this.listHistorial.splice(index, 1);
      this.listHistorial.push(node);
    } else {
      this.listHistorial.push(node);
    }

    if (this.listHistorial.length > 3) {
      this.listHistorial = this.listHistorial.slice(
        this.listHistorial.length - 3
      );
    }
    sessionStorage.setItem('listHisotrial', JSON.stringify(this.listHistorial));
  }

  favoriteList = (reloadMenu: boolean) => {

    this.favoritesService.getFavorites(Number(1));
    this.favoritesService.favorites$.subscribe(favorites => {
      if (favorites != null) {
        this.favorites = favorites;

        // this.getMainInformation();
      }
      this.getMenu(this.favorites, reloadMenu);
      // this.getMenunew(this.favorites, reloadMenu);

    })


  };
  private getMenu(favoriteList: any[], reloadMenu: boolean) {

    this.showLoading()


    this.mainHttpService.get(0).subscribe(resp => {
      this.menu = [];
      if (resp.isSuccessful) {
        this.menuSeven = resp.result;
        if (resp.result.length > 0) {
          for (let i = 0; i < this.menuSeven.length; i++) {
            this.menu.push({
              codigoPrograma: this.menuSeven[i].id,
              group: this.menuSeven[i].id,
              idForm: null,
              idMenu: this.menuSeven[i].id,
              idParent: this.menuSeven[i].parentId,
              name: this.menuSeven[i].text,
              url: this.menuSeven[i].text,
              active: false,
              icono: null
            })
            // this.onClicklistmenu(this.menuSeven[i].id,reloadMenu);
          }

        }
        this.closeLoading();
      }
      else {
        this._messagesService.error("Error conectando con el proveedor de menú");
      }
    });


    if (reloadMenu) {
      resetMenu();
    }
    // /     esperar a que se resuelva la promesa antes de llamar a miniMenu()
    this.waitForMenuLoad().then(() => {
      const body = document.querySelector('body');
      if (body && body.classList.contains('sp-aside--minimize')) {
        this.miniMenu();
      }
    });

  }

  obtenerUrlOdkl(page: Page) {
    const requestMenu = JSON.parse(
      this._commandService.getItemsessionStorage('requestMenu') || '{}'
    );
    this.tokenOph = btoa(requestMenu.usuario);
    const sessionData: responseLogin = JSON.parse(
      this._commandService.getItemsessionStorage('sessionData') || '{}'
    );
    const QueryInfo = {
      '0': page.codProg,
      '1': '',
      '3': '',
      '4': '',
      '5': '',
      '6': 'D', //validar de donde tomarla
    };
    const requestMessage: RequestMessage = {
      producto: requestMenu.producto,
      usuario: requestMenu.usuario,
      token: requestMenu.token,
      queryInfo: encryptString(JSON.stringify(QueryInfo)),
    };

  }
  addListfavorite(data: any) {
    this.listFavorite.push(data);
    this.menu[0].nodes?.map((node) => {
      this.listFavorite.forEach((favorite: any) => {
        if (node.codigoPrograma == favorite.cod_prog) {
          node.favorite = true;
        }
      });
    });
  }
  deletefavorite(cod_prog: any) {
    this.menu[0].nodes?.map((node) => {
      if (node.codigoPrograma == cod_prog) {
        node.favorite = false;
      }
    });

    let indx = this.listFavorite.findIndex((e: any) => e.cod_prog == cod_prog);
    if (indx != -1) {
      this.listFavorite.splice(indx, 1);
    }
  }

  tabEmitter() {
    // ocultar menu / reset
    this.ShowMenu = false;
    this.toggle();
    //this._pageService.repaintTabs();
    this.miniMenu();
    if (this.isMobile) this.CloseMenu();

  }
// Colapsar menú en escritorio
toggleCollapse() {
  this.isSidebarCollapsed = !this.isSidebarCollapsed;
  document.body.classList.toggle("sp-aside--minimize", this.isSidebarCollapsed);
}

// Abrir/cerrar menú en móvil
toggleDrawer() {
  this.isDrawerOpen = !this.isDrawerOpen;
  const aside = document.getElementById("sp_aside");
  if (aside) {
    aside.style.display = this.isDrawerOpen ? "block" : "none";
  }
}
  favoriteActive(node: any) {
    let idx = this.listFavorite.findIndex((e: any) => e.cod_prog == node.codigoPrograma)
    return idx != -1;
  }

  closeAllSubMenu() {
    let items = document.querySelectorAll('.altura');
    if (items) {
      items.forEach(el => {
        el.classList.remove('altura');
        el.removeAttribute("style");
      })
    }
  }
  miniMenu() {
    const that = this;
    const menuContex = document.querySelector("#sp_aside.side-mini-custom");
    // Verificar si el menú principal está expandido
    if (menuContex) {
      const submenus = menuContex.querySelectorAll(" .sp-menu__item--open .multi-level");
      // return

      // Resetear estilos para todos los submenús
      submenus.forEach((submenu: any) => {
        submenu.style.transition = "max-height 0.3s ease-out"; // Agregamos una transición suave
        submenu.style.maxHeight = ""; // Limpiamos la propiedad max-height
        submenu.style.top = ""; // Limpiamos la propiedad top

        setTimeout(() => {
          submenu.style.transition = ""; // Restauramos la transición después de cerrar
        }, 700);
      });
    }
    // return
    const positionElems = document.querySelectorAll(".multi-level.position");

    /* Si está colapsado agregamos la clase position */
    positionElems.forEach((elem) => {
      elem.classList.add("position");
    });
    // !this.validWidth() ? document.body.classList.add("sp-aside--minimize") : null
    /* Añadimos el side-mini-custom cuando se colapse el menú lateral */
    const elements = Array.from(document.getElementsByClassName('expanding'));
    elements.forEach((element: Element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.classList.toggle('side-mini-custom');
    });

    const parentElements = document.querySelectorAll(".sp-menu__item.sp-menu__item--submenu");
    let currentSubmenu: any = null;
    parentElements.forEach(function (parentElement) {

      const mouseoverEvent = new Event('mouseover', { bubbles: true });
      parentElement.dispatchEvent(mouseoverEvent);
      parentElement.addEventListener("mouseover", (event) => {

        if (document.querySelector("#sp_aside.side-mini-custom")) {

          const submenu = (<Element>event.currentTarget).querySelector("span.side-mini-custom") as HTMLElement;
          const parentRect = parentElement.getBoundingClientRect();
          if (submenu) {

            // Verificar si el submenú está abierto
            const isSubMenuOpen = parentElement.classList.contains('mm-active');

            // Lógica para el encabezado del menú lateral
            const submenuIcon = parentElement.querySelector("i.side-mini-custom") as HTMLElement;
            const arrow = parentElement.querySelector(".arrow-side-mini") as HTMLElement
            const menuItemPos = parentRect;
            if (!isSubMenuOpen) {
              // Aplicar estilos solo si el submenú no está abierto
              // that.applySubMenuStyles(submenu, parentRect);

              if (submenu) {
                try {
                  submenu.style.marginTop = "0px";
                  submenu.style.marginTop = "0px";
                  submenu.style.top = `calc(${menuItemPos.bottom - 15}px - 32px)`;
                  submenu.style.left = `calc(${menuItemPos.left}px + 78px)`;
                  submenuIcon.style.top = `calc(${menuItemPos.bottom}px - 32px)`;
                  submenuIcon.style.left = `calc(${menuItemPos.left}px + 78px)`;
                  submenuIcon.style.zIndex = "100";
                  arrow ? arrow.style.top = `calc(${menuItemPos.bottom + 15}px - 45px)` : '';
                } catch (error) {
                  console.log('mouseover- ', error);
                }
                event.stopPropagation();
              }
            } else {
              // Si el submenú está abierto, ajustar estilos específicos para el span
              const mainMenu = document.querySelector(".scrollbar-sidebar.menu-content") as HTMLElement
              const mainMenuRect = mainMenu.getBoundingClientRect();

              if (submenu) {
                submenu.style.marginTop = "0px";
                submenu.style.top = `calc(${mainMenuRect.bottom}px - 45px)`;
                submenu.style.left = `calc(${mainMenuRect.left}px + 93px)`;
                event.stopPropagation();
              }
            }
          }
        }
      });

      parentElement.addEventListener("click", function (event) {
        const menuContex = document.querySelector("#sp_aside.side-mini-custom");
        if (menuContex) {

          const submenu = (<Element>event.currentTarget).querySelector(".multi-level") as HTMLElement;
          const span = (<Element>event.currentTarget).querySelector("span.side-mini-custom") as HTMLElement;
          const parentRect = (<Element>event.currentTarget).getBoundingClientRect();
          if (submenu && submenu.style) {

            // Cerrar submenú anterior si está abierto
            if (currentSubmenu && currentSubmenu !== submenu) {
              that.resetSubMenuStyles(currentSubmenu);
            }

            const isSubMenuOpen = currentSubmenu === submenu;

            if (!isSubMenuOpen) {
              // Si el submenú no está abierto, lo abrimos
              that.applySubMenuStyles(submenu, parentRect, event, span);
              currentSubmenu = submenu;
            } else {
              // Si el submenú ya está abierto, lo cerramos
              that.resetSubMenuStyles(submenu, span);
              currentSubmenu = null;
            }
          }
        }
      });
    });
    this.validateClass();
  }
  applySubMenuStyles(submenu: HTMLElement, parentRect: DOMRect, event?: any, span?: any) {
    const viewportTop = window.scrollY || document.documentElement.scrollTop;
    setTimeout(() => {
      const submenuTop = parentRect.bottom + (viewportTop - 50);
      submenu.style.top = `${submenuTop}px`;
      const maxHeight = window.innerHeight - submenu.getBoundingClientRect().top - 10;
      submenu.style.maxHeight = `${maxHeight}px`;
      if (event) {
        if (parentRect.bottom > 430) {
          submenu.style.top = '';
          submenu.style.maxHeight = ``;
          submenu.style.bottom = `${(window.innerHeight - parentRect.top)}px`;
          submenu.style.borderRadius = `0.5rem 0.5rem 0 0`;
          span.style.borderRadius = `0 0 0.5rem 0.5rem`;
        }
      }
    }, 20);
    return submenu;
  }
  resetSubMenuStyles(submenu: HTMLElement, span?: any) {
    submenu.style.transition = "max-height 0.3s ease-out"; // Agregamos una transición suave
    submenu.style.maxHeight = ""; // Limpiamos la propiedad max-height
    span ? span.style.borderRadius = `` : '';  // Limpiamos la propiedad borderRadius
    // submenu.style.top = ""; // Limpiamos la propiedad top
    setTimeout(() => {
      submenu.style.transition = ""; // Restauramos la transición después de cerrar
    }, 700);
  }


  handleDocumentClick = (event: MouseEvent) => {
 
    const open = this.elRef.nativeElement.querySelectorAll('.sp-menu__item--open');
    if (!open.length) {
      return;
    }
    // verificamos si el menú está colapsado
    const menu = this.elRef.nativeElement.querySelector('.expanding');
    const isMenuCollapsed = menu.classList.contains('side-mini-custom');
    // verificamos si estamos haciendo clic por fuera del menú
    const submenus = this.elRef.nativeElement.querySelectorAll('.sp-menu__item--open');
    const positionsClass = this.elRef.nativeElement.querySelectorAll('div.position')
    const isOutsideClick = event.target instanceof Element && !event.target.closest('.sp-menu__item--open, .sp-menu__item--open *') && !event.target.closest('.menu-toggle, .menu-toggle *');
    if (isOutsideClick && isMenuCollapsed) {
      for (let i = 0; i < submenus.length; i++) {
        const submenu = submenus[i];
        submenu.classList.remove('sp-menu__item--open');
        const positionClass = positionsClass[i];
        // verificamos que la clase postion existe antes de tratar de eliminarla
        if (positionClass) {
          positionClass.classList.remove('position');
        }
      }
    }
  };


  hitoriclik(){
   
    if(this.listHistorialclick==false){
      this.listHistorialclick=true
    }
    else{
      this.listHistorialclick=false
    }

  }

  CloseMenu() {
    const aside = document.querySelector('aside.sp-aside.sp-aside--on');
    const body = document.body;
    if (aside && body) {
      sessionStorage.removeItem('toMenu');
      this._pageService.eventOpenMenu.emit(true)
      aside.classList.remove('sp-aside--on');
      body.classList.remove('sp-aside--on');
      body.classList.add('sp-aside--minimize');
      document.querySelector('.sp-aside-overlay')?.remove();
      document.querySelector('.sp-header-mobile__toolbar-toggler--active')?.classList.remove('sp-header-mobile__toolbar-toggler--active');
    }
  }

  toggle() {
    // pintar menu
    this.ShowMenu = true;
    if (this.newListener) document.body.classList.toggle("sp-aside--minimize");
    if (document.body.classList.contains('sp-aside--minimize')) {
      document.getElementById('side-arrow')?.classList.remove('fa-angles-left');
      document.getElementById('side-arrow')?.classList.add('fa-angles-right');
      this.isSidebarCollapsed=true;

    } else {
      document.getElementById('side-arrow')?.classList.remove('fa-angles-right');
      document.getElementById('side-arrow')?.classList.add('fa-angles-left');
      document.body.classList.remove("sp-aside--minimizing")
      this.isSidebarCollapsed=false;
    }
  }

  validateClass() {
    if (sessionStorage.getItem('toMenu') || this.validWidth()) this.renderer.addClass(document.body, 'sp-aside--minimize')
    const body = document.body;
    if (body && body.classList.contains('sp-aside--minimize')) {
      const aside = document.querySelector('aside.sp-aside');
      if (!aside?.classList.contains('side-mini-custom')) {
        aside?.classList.add('side-mini-custom')
      }
    }
  }

  showLoading() {
    this._spinnerService.loading();
  }

  closeLoading() {
    this._spinnerService.close();
  }

  toTitleCase(str: string): string {
    // return str
    // console.log(str.toLowerCase().split(' '));

    return str.toLowerCase().split(' ').map((word, i) => {
      if (i == 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      } else {
        return word

      }
    }).join(' ');
  }

  getMainBySearchBar(data: string) {
    this.mainService.loadMenuFilter(data).toPromise().then((data) => {
      this.isSearching = false;
      let e = { code: 'Enter' };
      this.ChangeDetectorRef.detectChanges();
      this.handlePropertyChange(null, e);
    })
  }

  lookForDataMenu() {
    this.mainService.main.asObservable().subscribe((resp) => {
      this.mainDataSearch = resp;
    });
  }

  handlePropertyChange(event, e) {

    if (e.code === "Enter" || e.code === "NumpadEnter") {
      if (event != null && event.length > 0) {
        this.getMainBySearchBar(event);

      }
    }

    if (event != null && event.length === 0) {
      this.isSearching = true;
    }
  }

  //
  onEnterPress(event: any) {

    if (this.userSearch == "" || this.userSearch == null) {
      this.favoriteList(true);
      this.isSearching = true;
      return
    }
    // Verifica si la tecla presionada es Enter (código 13)
    if (event.keyCode === 13) {
      // Aquí puedes realizar las acciones que deseas al presionar Enter
      this.keyEnter = true;
      setTimeout(() => {
        this.keyEnter = false;
        this.getMainBySearchBar(this.userSearch);
      }, 100);
    } else {
      this.keyEnter = false;
    }
  }
  Favorites() {
    this.ShowFavorites = !this.ShowFavorites;
  }
  lookForCompaniesChanges() {
    this.auth.currentUserSubject.asObservable()
      .subscribe(user => {
        if(this.auth.currentUserValue)
        {
          this.companynameSelect =  this.auth.currentUserValue.selectedCompany.name;
          this.auth.changeTokenCompany(Number(this.codEmpresa)).subscribe(resp => {
          })
        }
  
      });
  }

  async selectEmpresa(event: any) {


    this.eventSelectEnterprise.emit(event);
    if (this.codEmpresa != event.value) {
      this._spinnerService.loading();

      const result = this.companies.filter(
        obj =>
          obj.code == event.value
      );

      let rsult = await this.auth.updatecompany(result);
      this.lookForCompaniesChanges();
      sessionStorage.setItem('Codigo empresa', event.value)

      const sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
      sessionData.selectedCompany.code=event.value

      this._commonService.setItemsessionStorage('sessionData', sessionData);

      this.codEmpresa = event.value;
      this.variable = true;
      let that = this;

if(this.router.url=="/dashboard"){
  this._spinnerService.close();
  window.location.reload();
  
}
else{
 
  setTimeout(() => {
    this.variable = false;
  }, 1000);
  setTimeout(function () {
    that.auth.getUserByToken();
    that.pages = [];
    that.removeClass("open-item");
    that.CloseRightMenu();
    // sessionStorage.setItem('Pages', JSON.stringify(this.pages));
    sessionStorage.removeItem('Pages');
    that._spinnerService.close();
    that._router.navigate(['/dashboard']);
    window.location.reload();
  }, 1000);
}

    }


  }

  CloseRightMenu() {
    try {
      let ctxMenu: any = document.getElementById("content-menu");
      ctxMenu.style.display = "";
      ctxMenu.style.left = "";
      ctxMenu.style.top = "";
      this.rightMenuOpened = false;
    } catch (err) { }
  }

  onClosedEmpresa(event: any) {
    // this.codEmpresa = this.empresaSelect[0].cod_empr;
  }

  enviarEmpresaForms(event: any) {
    this._commonService.eventEmpresa.emit({ type: "empresa", data: event })
  }

  saveMobile = () => {
    // this.miniMenu();
    this.validateClass();
    if (this.isMobile !== this.validWidth()) {
      this.CloseMenu();
      if (!this.validWidth()) this.newListener = true;
    }
    // else if(!this.isMobile) resetMenu();
    this.isMobile = this.validWidth();
    // this.miniMenu();
  }

  validWidth = () => {
    // this.validateClass()
    if (window.innerWidth <= 768) {
      return true
    } else {
      return false;
    }
  }

  clickMain(e) {


    if (e.itemData.hasItems) {
      if (e.itemData.expanded) {
        this.treeView.instance.collapseItem(e.itemData);
      }
      else
        this.treeView.instance.expandItem(e.itemData);
    }
    else {
      this.openMicroApp(e.itemData);
    }


  }

  clickMainsearch(e) {

    if (e.hasItems) {
      if (e.expanded) {
        this.treeView.instance.collapseItem(e);
      }
      else
        this.treeView.instance.expandItem(e);
    }
    else {
      this.openMicroApp(e);
    }


  }

  GetGlobalVariables(param: ResourceParameter) {
    if (param.type == 0) {
      return param.value;
    } else {
      switch (param.code) {
        case "token":
          return this.auth.getAuthFromLocalStorage().accessToken;
        case "companyCode":
          return this.sessionData.selectedCompany.code;
      }
    } return null
  }



  openMicroApp(itemObj: any) {

    this._spinnerService.loading();
    if (!itemObj.isAuth) {

      this._messagesService.error('Programa no autorizado para usuario');
      this._spinnerService.close();
      return;
    }
    this.microapps.GetMicroApplicationsById(itemObj.microApplicationId).subscribe((microApp) => {
      if (microApp.isSuccessful) {
        let url = `${microApp.result.url}?`;
        // this.data=microApp;
        this.Linkdata = [];
        if (microApp.result.link.length >0) {
          for (let i = 0; i < microApp.result.link.length; i++) {
          this.Linkdata.push({
            __KEY__:microApp.result.link[i]. __KEY__,
            Code:microApp.result.link[i].code,
            Description:microApp.result.link[i].description,
            MicroApplication_Id:microApp.result.link[i].microApplication_Id
            
             
          });
        }
      }


        this.tokeshistori = this.auth.getAuthFromLocalStorage().accessToken;
        this.codigoForm = microApp.result.code;
        if (microApp.result.parameters != null) {
          let i = 0;
          for (const parameter of microApp.result.parameters) {

            url += `${i === 0 ? '' : '&'}${parameter.code}=${this.GetGlobalVariables(parameter)}`;
            i += 1;
          }

          this.html = url;
          this.url.next(this.sanitizer.bypassSecurityTrustResourceUrl(url));
          this.html = this.sanitizer.bypassSecurityTrustResourceUrl(url)
          this.pagesSe.length = 0;
          this.pagesSe.push({
            codProg: itemObj.parentId,
            name:  itemObj.text,
            idForm: itemObj.microApplicationId,
            id: itemObj.id,
            url: url,
            cambiarUrl: true,
            // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
            typeForm: 'maestro',
            lisnk:this.Linkdata
          })

          const page: Page = {
            codProg: itemObj.parentId,
            name: itemObj.text,
            idForm: itemObj.microApplicationId,
            id: itemObj.id,
            url: null,
            cambiarUrl: true,
            // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
            typeForm: 'maestro',
            lisnk:this.Linkdata
          };
          this.removeClass('open-item');
          this._spinnerService.close();

     
          page.url = url;

          this._commonService.setItemsessionStorage('Pages', this.pagesSe);
          this.router.navigate(['/pageTabPanel']);

          this.addHistorial(page);
          this._pageService.generarPage(page)
       



        }
      }
      else
      {
        this._spinnerService.close();
        this._messagesService.error(microApp.errorMessage);
   
      }
    }, err => {

      this._messagesService.error('Error conectando con servicio de microaplicaciones');
    });



  }

}
